/**
 * CopilotKitProvider — wraps CopilotKit for AG-UI agent communication.
 *
 * Only active for agents listed in AGUI_AGENTS. For legacy agents,
 * this provider is transparent (CopilotKit is mounted but unused).
 *
 * Auth: X-Id-Token + X-Access-Token via gatewayAuthHeaders (mirrors legacy SSE path).
 */

import { CopilotKit } from '@copilotkit/react-core/v2';
import type { ReactNode } from 'react';
import { appConfig } from '../../../config';
import { gatewayAuthHeaders } from '../../../context/gatewayAuthHeaders';

interface CopilotKitProviderProps {
  children: ReactNode;
}

export default function CopilotKitProvider({ children }: CopilotKitProviderProps) {
  return (
    <CopilotKit
      runtimeUrl={`${appConfig.gatewayUrl}/channels/agui/rocky/events`}
      useSingleEndpoint={true}
      properties={{ protocol: 'ag-ui' }}
      headers={(): Record<string, string> => gatewayAuthHeaders()}
    >
      {children}
    </CopilotKit>
  );
}
